import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useLanguage } from "../../contexts/LanguageContext";
import "./Social.css";

const INSTAGRAM_URL = "https://www.instagram.com/psy.illuminate";
const LINKEDIN_URL = "https://www.linkedin.com/in/foteini-dritseli-649858375/";

const Social: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="social" id="connect">
      <h2>{t("social.title")}</h2>
      <p className="social-subtitle">{t("social.subtitle")}</p>

      <div className="social-links-row">
        <a
          className="social-link instagram"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram @psy.illuminate"
        >
          <span className="social-link-icon">
            <InstagramIcon />
          </span>
          <span className="social-link-text">
            <strong>Instagram</strong>
            <span>@psy.illuminate</span>
            <em>{t("social.instagramDesc")}</em>
          </span>
          <OpenInNewIcon className="social-link-external" fontSize="small" />
        </a>

        <a
          className="social-link linkedin"
          href={LINKEDIN_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn Foteini Dritseli"
        >
          <span className="social-link-icon">
            <LinkedInIcon />
          </span>
          <span className="social-link-text">
            <strong>LinkedIn</strong>
            <span>Foteini Dritseli</span>
            <em>{t("social.linkedinDesc")}</em>
          </span>
          <OpenInNewIcon className="social-link-external" fontSize="small" />
        </a>
      </div>
    </section>
  );
};

export default Social;
